import { useShortBrand } from "@/contexts/cdpConfig";
import { useContactSections } from "@/contexts/contact";
export const useCallTrackingRequest = () => {
    var _a;
    const shortBrand = useShortBrand();
    const { agencyId } = useContactSections();
    const { phoneNumbers = [] } = (_a = useContactSections().contactCard) !== null && _a !== void 0 ? _a : {};
    const calltrackingRequestParams = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
            agencyId: agencyId, //agencyId: agencyId,
            brand: shortBrand,
            realPhoneNumbers: phoneNumbers,
        },
    };
    return {
        method: calltrackingRequestParams.method,
        headers: calltrackingRequestParams.headers,
        body: JSON.stringify(calltrackingRequestParams.body),
    };
};
